/**
 * ColaboradorApiClient -- HTTP client for /api/v1/businesses/{businessId}/colaboradores.
 * All operations are scoped to a specific business.
 *
 * @module infrastructure/api/ColaboradorApiClient
 */

import { ApiBase } from './ApiBase.js';

function basePath(businessId) {
  return `/api/v1/businesses/${businessId}/colaboradores`;
}

export const ColaboradorApiClient = {
  async list(businessId, page = 1, pageSize = 20, estado = '', search = '') {
    let url = `${basePath(businessId)}?page=${page}&pageSize=${pageSize}`;
    if (estado) url += `&estado=${encodeURIComponent(estado)}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return ApiBase.get(url);
  },

  async getById(businessId, id) {
    return ApiBase.get(`${basePath(businessId)}/${id}`);
  },

  async create(businessId, colaborador) {
    return ApiBase.post(basePath(businessId), colaborador);
  },

  async update(businessId, id, colaborador) {
    return ApiBase.put(`${basePath(businessId)}/${id}`, colaborador);
  },

  async remove(businessId, id) {
    return ApiBase.del(`${basePath(businessId)}/${id}`);
  },

  /**
   * R-T3 VERIFICACION-CONFIG-ASIGNACION-V1-001 (canon v1.3, forense #1926):
   * la asignacion grupo-conteo del operador kiosk vive en COLABORADORES.
   * PATCH /api/v1/businesses/{businessId}/colaboradores/{id}/grupo-conteo
   * Body {grupoConteoId: int|null, grupoConteoReemplazoId: int|null} -- espejo
   * exacto de UsuariosApiClient.actualizarGrupoConteo (contrato API R-T2 live).
   */
  async actualizarGrupoConteo(businessId, id, { grupoConteoId, grupoConteoReemplazoId } = {}) {
    if (!businessId || !id) return { ok: false, error: { code: 'PARAMS_REQUIRED' } };
    return ApiBase.patch(`${basePath(businessId)}/${encodeURIComponent(id)}/grupo-conteo`, {
      grupoConteoId: grupoConteoId ?? null,
      grupoConteoReemplazoId: grupoConteoReemplazoId ?? null
    });
  }
};
